import once from '@lib/once';
import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
import { EffectFade } from 'swiper/modules';

export default function initBigStage(element) {
    const autoscrollingTime = element.dataset['autoscrollingTime'] || 4000;

    const hammer = new Hammer.Manager(element);
    hammer.add(new Hammer.Swipe({ direction: Hammer.DIRECTION_HORIZONTAL }));

    let current = 0;
    const line = element.querySelector('.big-stage__line');
    const stories = Array.from(element.querySelectorAll('.big-stage-story'));
    const prevButton = element.querySelector('.big-stage__prev');
    const nextButton = element.querySelector('.big-stage__next');

    function update() {
        const width = window.innerWidth;
        line.style.transform = `translate3d(-${current * width}px, 0, 0)`;
        stories.forEach((story) => story.classList.remove('is-active'));
        stories[current].classList.add('is-active');
        prevButton.style.visibility = current === 0 ? 'hidden' : 'visible';
        nextButton.style.visibility = current === stories.length - 1 ? 'hidden' : 'visible';
    }

    function next() {
        current = Math.min(stories.length - 1, current + 1);
        update();
    }

    function prev() {
        current = Math.max(0, current - 1);
        update();
    }

    hammer.on('swipeleft', next);
    hammer.on('swiperight', prev);

    prevButton.addEventListener('click', prev);
    nextButton.addEventListener('click', next);

    window.addEventListener('resize', function () {
        update();
    });

    update();

    element.classList.add('jsified');

    setInterval(function () {
        current = (current + 1) % stories.length;
        update();
    }, autoscrollingTime);
}

window.Drupal.behaviors.bigStage = {
    attach: function (context) {
        context.querySelectorAll('.big-stage').forEach(function (element) {
            once('bigStage', () => initBigStage(element), [element]);
        });
    },
};

window.Drupal.behaviors.bigStageSwiper = {
    attach: function (context) {
        context.querySelectorAll('.big-stage-slides__items--slider').forEach((element) => {
            once(
                'bigStageSlider',
                (element) => {
                    new Swiper(element.querySelector('.swiper'), {
                        modules: [Navigation, EffectFade],
                        navigation: {
                            nextEl: element.querySelector('.swiper-button-next'),
                            prevEl: element.querySelector('.swiper-button-prev'),
                        },
                        speed: 800,
                        autoHeight: true,
                        effect: 'fade',
                        fadeEffect: {
                            crossFade: true,
                        },
                    });
                },
                [element]
            );
        });
    },
};
